// @columns: ordered array of columns (with names, and possibly other options)
// e.g. [{ name: "Title", id: "title"}]
// @data: array of row objects
// e.g. [{title: "Hello"}]
export default function Table({ columns, data }) {
  return (
    <table className="table table-hover">
      <thead>
        <tr>
          {columns.map(({ name: label, id }) => (
            <th key={id}>{label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            {columns.map(({ id }) => (
              <td key={id}>{row[id]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
